document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.footer .navigation__list > .section__title').forEach((title) => {
        title.addEventListener('click', () => {
            const titleAfterStyles = window.getComputedStyle(title, '::after');

            if (titleAfterStyles.backgroundImage === 'none') {
                return;
            }

            const navigationList = title.closest('.navigation__list');

            if (!navigationList) {
                return;
            }

            if (navigationList.dataset.visibility === 'visible') {
                delete navigationList.dataset.visibility;
                return;
            }

            navigationList.dataset.visibility = 'visible';
        });
    });
});
